import { isNative } from '../platform/capacitor';
import { storageGet, storageSet } from '../platform/storage';
import { v2Request } from './client';

export const isLikelyApnsToken = (tokenValue) =>
  typeof tokenValue === 'string' && /^[a-f0-9]{64}$/i.test(tokenValue.trim());

const SYNC_TOKEN_KEY = 'v2_push_sync_token';
const SYNC_MOBILE_KEY = 'v2_push_sync_mobile';
const NEPTUNE_TOKEN_KEY = 'v2_push_neptune_token';

/** True after first-open guest sync (NEPTUNE). Used to skip token API after logout. */
export async function isGuestNeptuneAlreadySynced() {
  const v = await storageGet(NEPTUNE_TOKEN_KEY);
  return v != null && v !== '';
}

function normalizeMobile(raw) {
  return String(raw || '').replace(/\D/g, '').slice(-10);
}

/** @param {{ deviceToken: string, mobile?: string }} body */
export function syncPushTokenToBackend({ deviceToken, mobile }) {
  const payload = { deviceToken };
  const digits = mobile != null ? normalizeMobile(mobile) : '';
  if (digits.length === 10) payload.mobile = digits;
  return v2Request('/api/auth/device-token', {
    method: 'POST',
    body: payload,
  });
}

/**
 * Sync FCM token to Pilot (native only). Guest = NEPTUNE only; logged-in = NEPTUNE + user doc.
 * @param {{ deviceToken: string, mobile?: string, forceUserDoc?: boolean }} params
 */
export async function syncPushTokenIfNeeded({ deviceToken, mobile, forceUserDoc = false }) {
  if (!isNative() || !deviceToken) return;
  if (isLikelyApnsToken(deviceToken)) return;

  const digits = mobile != null ? normalizeMobile(mobile) : '';
  const isLoggedIn = digits.length === 10;

  if (isLoggedIn && !forceUserDoc) {
    const lastToken = await storageGet(SYNC_TOKEN_KEY);
    const lastMobile = await storageGet(SYNC_MOBILE_KEY);
    if (lastToken === deviceToken && lastMobile === digits) {
      console.log('[v2-push] skip user sync (dedupe)', { mobile: digits });
      return;
    }
  } else if (!isLoggedIn) {
    const lastNeptune = await storageGet(NEPTUNE_TOKEN_KEY);
    if (lastNeptune === deviceToken) {
      console.log('[v2-push] skip guest sync (dedupe)');
      return;
    }
  }

  const mode = isLoggedIn ? 'neptune_and_user' : 'neptune_only';
  console.log('[v2-push] syncing', { mode, mobile: isLoggedIn ? digits : null, forceUserDoc });

  try {
    await syncPushTokenToBackend({
      deviceToken,
      mobile: isLoggedIn ? digits : undefined,
    });
    await storageSet(NEPTUNE_TOKEN_KEY, deviceToken);
    if (isLoggedIn) {
      await storageSet(SYNC_TOKEN_KEY, deviceToken);
      await storageSet(SYNC_MOBILE_KEY, digits);
    }
    console.log('[v2-push] sync ok', { mode, mobile: isLoggedIn ? digits : null });
  } catch (err) {
    console.warn('[v2-push] sync failed', err?.message || err);
  }
}
